import React, { Dispatch, Fragment, SetStateAction } from 'react';
import { VendorStoreItemType } from 'models/vendors.model';
import CurrencyInput from 'components/base/currency-input';
import useDashboardContext from 'contexts/dashboard.context';
import SelectDropdown from 'components/base/select-dropdown';
import ActivityIndicator from 'components/base/loader/activityIndicator';

const defaultItem: VendorStoreItemType = {
  id: '',
  ingredient_id: '',
  gram_price: '',
  vendor_id: '',
  ingredient: {
    name: '',
    unit_weight: '',
    unit_type: ''
  }
};
const UpdateVendorStoreDetails = ({
  storeItemsToEdit,
  setStoreItemsToEdit,
  vendorIngredientIdsToDelete,
  setVendorIngredientIdsToDelete,
  isFetchingStoreItems
}: {
  storeItemsToEdit: VendorStoreItemType[];
  setStoreItemsToEdit: Dispatch<React.SetStateAction<VendorStoreItemType[]>>;
  vendorIngredientIdsToDelete: string[];
  setVendorIngredientIdsToDelete: Dispatch<SetStateAction<string[]>>;
  isFetchingStoreItems: boolean;
}) => {
  const { formStoreItems } = useDashboardContext();

  // useEffect(() => {
  //   setVendorToEdit({ ...vendorToEdit, ingredients: items });
  // }, [storeItemsToEdit]);

  const handleInputChange = (e: any, index: number) => {
    const { name, value }: { name: 'ingredient_id' | 'gram_price'; value: string } = e.target;
    if (storeItemsToEdit) {
      const newItems = storeItemsToEdit.map((b) => ({ ...b }));
      newItems[index][name] = value;
      setStoreItemsToEdit(newItems);
    }
  };
  const addItems = () => {
    if (storeItemsToEdit) setStoreItemsToEdit([...storeItemsToEdit, defaultItem]);
    else setStoreItemsToEdit([defaultItem]);
  };

  const removeItems = (index: number) => {
    setStoreItemsToEdit((prev) => prev && prev.filter((item, i) => index !== i));
  };

  const selectedIngredient = (id: string) => {
    return id
      ? formStoreItems.filter((ingredient) => ingredient.id === id)[0]
      : { name: '', unit_type: '' };
  };

  return (
    <div>
      {isFetchingStoreItems ? (
        <div>
          <ActivityIndicator />
        </div>
      ) : (
        <Fragment>
          <div className='flex flex-col gap-4'>
            {storeItemsToEdit &&
            storeItemsToEdit.filter(
              (vendor_ingredient) => !vendorIngredientIdsToDelete.includes(vendor_ingredient.id)
            ).length > 0 ? (
              storeItemsToEdit
                .filter(
                  (vendor_ingredient) => !vendorIngredientIdsToDelete.includes(vendor_ingredient.id)
                )
                .map(({ ingredient_id, gram_price, id }, index) => (
                  <div key={index}>
                    <div className='grid grid-cols-2 gap-4'>
                      <SelectDropdown
                        label='Item name'
                        placeholder='Select item'
                        value={selectedIngredient(ingredient_id).name}
                        setValue={(item) =>
                          handleInputChange(
                            { target: { name: 'ingredient_id', value: item.id } },
                            index
                          )
                        }
                        options={formStoreItems.filter((item) => {
                          return !storeItemsToEdit.some(
                            (selected) => selected.ingredient_id === item.id
                          );
                        })}
                        disabled={!!id}
                        // hasSearch
                      />
                      <CurrencyInput
                        name='price'
                        label='Price per qty'
                        placeholder=' 2,000'
                        hasUnit
                        disableUnit
                        explicitRender
                        value={gram_price}
                        unitValue={selectedIngredient(ingredient_id).unit_type}
                        decimalsLimit={2}
                        onChange={(value) =>
                          handleInputChange({ target: { name: 'gram_price', value } }, index)
                        }
                      />
                    </div>
                    <div className='flex justify-end'>
                      <button
                        onClick={() =>
                          id
                            ? setVendorIngredientIdsToDelete((prev) => [...prev, id])
                            : removeItems(index)
                        }
                        className='text-[#E60A2B] mt-2 font-medium text-sm '>
                        - Remove Item
                      </button>
                    </div>
                  </div>
                ))
            ) : (
              <div className=''>
                <h4>No store items</h4>
              </div>
            )}
          </div>
          <button onClick={addItems} className='text-[#0080E5] font- medium text-sm'>
            + Add Item
          </button>
        </Fragment>
      )}
    </div>
  );
};

export default UpdateVendorStoreDetails;
